import * as Yup from "yup";
import { nameRegEx } from "./utils/schema";

export const locationSchema = {
  address: Yup.string()
    .required("Required.")
    .matches(...nameRegEx),
};
